import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { getCurrentNativeAppVersionFromUserAgent } from '@dhl/native-bridge'
import { useVersion } from '@dhl/version-provider'
import { isNative } from '@dhl/webview'
import { dataLayerUpdate } from '@dhl/datalayer'
import { type DataLayerMeta } from './types/types.js'

type Props = {
  isLoggedIn: boolean
  topLevelDomain?: string
}

/**
 * This hook will update the internal datalayer with generic information, without doing so in several places.
 * This meta information will be set in the stored data from the internal datalayer. This can be used to send
 * these meta information to the connected providers.
 */
export const useDataLayerMeta = ({ isLoggedIn = false, topLevelDomain = 'NL' }: Props): void => {
  // TODO: Don't depend on the version provider, but instead provide the version as a prop. This prevents coupling the Version Filter functionality with this DataLayerMeta functionality.
  const { version } = useVersion()
  const { i18n } = useTranslation()

  useEffect(() => {
    const nativeAppVersion = getCurrentNativeAppVersionFromUserAgent()
    dataLayerUpdate(<DataLayerMeta>{
      app: {
        isNative: isNative(),
        nativeVersion: nativeAppVersion,
        releaseVersion: version,
        locale: i18n.language.split('-')[0].toUpperCase(),
        tld: topLevelDomain.toUpperCase(),
      },
      user: {
        status: isLoggedIn ? 'logged-in' : 'logged-out',
        type: 'external',
      },
    })
  }, [i18n.language, isLoggedIn, topLevelDomain, version])
}
